import { ErrorMessage } from 'aa_common/front-end/antd'
import { LinkLabel } from 'aa_common/front-end/components'
import InputNumber from 'aa_common/front-end/components/form/form-input-number'
import { yenCheckNull } from 'common/helpers'
import { useNextEffect } from 'common/hooks/use-next-effect'
import { getNs } from 'common/i18n-config'
import { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'

import { AntInputAlignRight, SmallLabelClass } from '../styles'
import { FIELD_NAMES } from '../validation'

type ImpairmentLostProps = {
  impairmentAmountMaximum?: number
}

const { t, useNsReady } = getNs(['components/organisms/assets/asset-impairment'])

const FieldName = FIELD_NAMES.impaired_amount

export const ImpairmentLost = ({ impairmentAmountMaximum }: ImpairmentLostProps) => {
  useNsReady()
  const { setValue } = useFormContext()

  useNextEffect(() => {
    setValue(FIELD_NAMES.impaired_amount_maximum, impairmentAmountMaximum)
    setValue(FieldName, impairmentAmountMaximum)
  }, [impairmentAmountMaximum, setValue])

  const setFullImpairment = useCallback(() => {
    setValue(FieldName, impairmentAmountMaximum, {
      shouldValidate: true,
    })
  }, [setValue, impairmentAmountMaximum])

  return (
    <>
      <InputNumber
        name={FieldName}
        className={AntInputAlignRight}
        formatter={value => `${yenCheckNull(value)}`}
        controls={false}
        isShowError={false}
      />
      <LinkLabel className={SmallLabelClass} onClick={setFullImpairment}>
        {t('impair_entire_book_value')}
      </LinkLabel>
      <ErrorMessage name={FieldName} errors={null} />
    </>
  )
}
